import React from 'react';
import JotformEmbed from '@/components/JotformEmbed';
import { useLang } from '@/i18n/LanguageContext';
import { useNavigate } from 'react-router-dom';
import { ShieldCheck } from 'lucide-react';

const Application = () => {
  const { t, lang } = useLang();
  const navigate = useNavigate();

  return (
    <div className="pt-24 pb-16 min-h-screen bg-slate-50">
      
      {/* Brief Accreditation Banner for Trust */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 mb-8">
        <div className="bg-white rounded-2xl p-4 shadow-sm border border-slate-200 flex flex-col sm:flex-row items-center justify-center sm:justify-between gap-4 text-center sm:text-left">
          <div className="flex items-center gap-3">
            <ShieldCheck className="w-6 h-6 text-emerald-500 shrink-0" />
            <p className="text-sm font-medium text-slate-700">
              {lang === 'en' 
                ? 'Royal Dental Assistant Academy is licensed by the North Carolina State Board of Community Colleges.'
                : 'Royal Dental Assistant Academy está licenciada por la Junta Estatal de Colegios Comunitarios de NC.'}
            </p>
          </div>
          <button 
            onClick={() => { navigate('/about'); setTimeout(() => document.getElementById('accreditation')?.scrollIntoView({ behavior: 'smooth' }), 100); }}
            className="text-sm font-bold text-brand-primary hover:text-brand-primary/80 transition-colors whitespace-nowrap"
          >
            {t.footer.viewAccreditation}
          </button>
        </div>
      </div>

      <JotformEmbed formId="232094520728051" />
    </div>
  );
};

export default Application;
